import { useMemo } from "react";

import { useFeatureFlagPreloader } from "@/domain/_shared/feature-flag/hooks/api/use-feature-flag-preloader";
import { useCheckPermissionList } from "@/domain/_shared/permission/hooks/api/use-check-permission-list";
import { ACTION_TYPES, type ActionType } from "@/domain/_shared/permission/models/permission-types";
import { useGetClimateActionListForWorkspace } from "@/domain/climate-action/hooks/api/use-get-climate-action-list-for-workspace";
import { useTeamListForWorkspace } from "@/domain/team/hooks/api/use-team-list-for-workspace";
import { useWorkspaceMembershipList } from "@/domain/workspace/hooks/api/use-workspace-membership-list";

interface UsePreLoaderProps {
  workspaceId: string;
  userId: string;
}

export const usePreLoader = ({ workspaceId }: UsePreLoaderProps) => {
  // load data for all teams
  const teamQueryResults = useTeamListForWorkspace({
    workspaceId,
    shouldUpdateCache: true,
  });
  const userQueryResults = useWorkspaceMembershipList({ workspaceId });

  const climateActionListForWorkspaceQueryResults = useGetClimateActionListForWorkspace({
    workspaceId,
  });

  const useCheckPermissionListQueryResults = useCheckPermissionList({
    permissions: ACTION_TYPES.map((action) => {
      return {
        resource: "workspace",
        action: action as ActionType,
        resourceId: workspaceId,
      };
    }),
  });

  const featureFlagPreloaderResults = useFeatureFlagPreloader({
    workspaceId,
  });

  const loading = useMemo(() => {
    return (
      teamQueryResults.loading ||
      userQueryResults.loading ||
      climateActionListForWorkspaceQueryResults.loading ||
      useCheckPermissionListQueryResults.loading ||
      featureFlagPreloaderResults.loading
    );
  }, [
    teamQueryResults,
    userQueryResults,
    climateActionListForWorkspaceQueryResults,
    useCheckPermissionListQueryResults,
    featureFlagPreloaderResults,
  ]);

  return {
    loading,
  };
};
